import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { REDIRECT_URL_KEY } from 'configs/AppConfig'
import { getDefaultAuthenticatedPath, getSafeRedirect, isStaffUser } from 'utils/authRedirect'

const PublicRoute = () => {
	const { token, user } = useSelector(state => state.auth || {})
	const location = useLocation()

	if (!token) {
		const redirectParam = new URLSearchParams(location.search).get(REDIRECT_URL_KEY)
		const requestedPath = getSafeRedirect(redirectParam, '')

		if (location.pathname === '/login' && requestedPath.startsWith('/admin/')) {
			return <Navigate to={`/admin?${REDIRECT_URL_KEY}=${encodeURIComponent(requestedPath)}`} replace />
		}

		return <Outlet />
	}

	const redirectParam = new URLSearchParams(location.search).get(REDIRECT_URL_KEY)
	const fallback = getDefaultAuthenticatedPath(user)
	let destination = getSafeRedirect(redirectParam, fallback)

	if (destination.startsWith('/admin/') && !isStaffUser(user)) {
		destination = fallback
	}

	return <Navigate to={destination} replace />
}

export default PublicRoute
